import {observer} from 'mobx-react-lite'
import React, {useEffect} from 'react'
import tw from 'tailwind-styled-components'
import useResizeObserver from 'use-resize-observer'
import {useCalendarStore} from '../calendar-store'
import {useSlider} from './slider-hook'

const SliderTw = tw.div`
  relative
  overflow-hidden
  h-full
  w-full
`

const SliderContentTw = tw.div`
  flex
  flex-nowrap
  overflow-hidden
  relative
  h-full
  w-full
`

const SliderItemTw = tw.div`
  w-full
  h-full
`

interface Props {
  children: React.ReactNode
}

export const Slider = observer(({children}: Props) => {
  const {ref, width} = useResizeObserver()
  const [, store] = useCalendarStore()
  const slides = React.Children.toArray(children)
  const length = slides.length

  const [active, setActive, handlers, style] = useSlider(length)

  useEffect(() => {
    switch (active) {
      case 0: {
        store.changeWeekHandle('prev')
        setActive(1, true)
        break
      }
      case 2: {
        store.changeWeekHandle('next')
        setActive(1, true)
        break
      }
    }
  }, [active])

  return (
    length > 0 && (
      <SliderTw ref={ref}>
        <SliderContentTw {...handlers} style={style}>
          {slides.map((slide, index) => (
            <SliderChild key={index} width={width}>
              {slide}
            </SliderChild>
          ))}
        </SliderContentTw>
      </SliderTw>
    )
  )
})

const SliderChild = ({
  children,
  width
}: {
  children: React.ReactNode
  width: number
}) => {
  return <SliderItemTw style={{width}}>{children}</SliderItemTw>
}
